export { default } from './OrderStripsPopup';
